import { useReportId } from 'hooks/helperHooks';

import { Loader, Modal, Typography } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';

type Props = {
  isLoadingReport: boolean;
};

const LoadingModal = ({ isLoadingReport }: Props) => {
  const { isCreate } = useReportId();
  const { t } = useTranslation();

  return (
    <Modal
      title={isCreate ? t('LoadingModal.title.creating') : t('LoadingModal.title.loading')}
      open={isLoadingReport}
      onClose={() => {}}
      componentsProps={{ headerBaseCloseIcon: { icon: null } }}
      isHeaderSeparatorHidden={true}
    >
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
        <Loader size='large' />
        <Typography component='div'>{t('LoadingModal.message')}</Typography>
      </div>
    </Modal>
  );
};

export default LoadingModal;
